import React from 'react'
import NewPassword from '../../../components/form/newPassword';

function NewPasswordPage() {
  return (
    <NewPassword/>
  )
}

export default NewPasswordPage;